import { render, staticRenderFns } from "./ShippingMap.vue?vue&type=template&id=37a941fe"
import script from "./ShippingMap.vue?vue&type=script&lang=js"
export * from "./ShippingMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports